import type { PontoEvent } from '../types/PontoEvent.ts';
import { LocalStorage } from '../storages/LocalStorage.ts';
import { DatabaseStorage } from '../storages/DatabaseStorage.ts';
import { PontoEventParser } from '../parsers/PontoEventParser.ts';
import type { AuthContextProps } from 'react-oidc-context';
import { DateFormatter } from '../serializers/DateFormatter.ts';
import { Serializer } from '../serializers/Serializer.ts';

export class Events {
    private events: PontoEvent[];
    private local_storage: LocalStorage<PontoEvent>;
    private database_storage: DatabaseStorage<PontoEvent>;
    private ref_date_formatter: DateFormatter;
    private local_key: string;
    private user_id: string;
    constructor(auth: AuthContextProps, events?: PontoEvent[]) {
        if (!auth.user?.profile?.sub) {
            throw new Error('User is not authenticated');
        }
        this.user_id = auth.user?.profile?.sub;
        this.ref_date_formatter = new DateFormatter('yyyy-MM-dd');
        this.local_key = this.ref_date_formatter.format(new Date());
        this.local_storage = new LocalStorage(this.local_key, new PontoEventParser());
        this.database_storage = new DatabaseStorage<PontoEvent>('ponto',
            'user_id',
            'ref_date',
            new Serializer<PontoEvent>({
            'dataHora': new DateFormatter('yyyy-MM-dd hh:mm:ss.SSS XXX')
            }),
            new PontoEventParser(),
            auth);
        this.events = events ?? (this.local_storage.get() as PontoEvent[] || [] as PontoEvent[]);
    }

    public async initialize(): Promise<void> {
        const localEvents = this.local_storage.get();
        if (localEvents) {
            this.events = localEvents;
        } else {
            const dbEvents = await this.database_storage.get(this.user_id, this.local_key);
            this.events = dbEvents ?? [];
            this.local_storage.set(this.events);
        }
    }

    public add(event: PontoEvent): void {
        this.events.push(event);
        this.local_storage.set(this.events);
        this.database_storage
            .append(event, this.user_id, this.ref_date_formatter.format(event.dataHora))
            .then(() => {})
            .catch((error: Error) => console.error('Error saving event to database:', error));
    }

    public get(): PontoEvent[] {
        return this.events;
    }
}
